import { render, staticRenderFns } from "./leftMenus.vue?vue&type=template&id=437b8b49&scoped=true"
import script from "./leftMenus.vue?vue&type=script&lang=js"
export * from "./leftMenus.vue?vue&type=script&lang=js"
import style0 from "./leftMenus.vue?vue&type=style&index=0&id=437b8b49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437b8b49",
  null
  
)

export default component.exports